module.exports = "./img/aac0b764d1b606fb8a44a35dd64ea4e7.jpg";